module.exports = __webpack_public_path__ + "img/icon-kindundschule.d90aa772.svg";